import { Component, TemplateFunction } from '@ribajs/core'
import { isInMarketAllowlist, redirectToPath } from '../utils/index.js'
import { ShopifyBlogService } from '../services/index.js'

interface Scope {
  // OPTIONS

  /** The collection handle */
  handle?: string
  /** If true the collection will be loaded dynamic without a page reload, otherwise */
  dynamic: boolean
  /** The allowed markets */
  allowedMarkets: string[]

  // METHODS

  load: SbSubBlogComponent['load']
}

export class SbSubBlogComponent extends Component {
  public static tagName = 'sb-sub-blog'

  static get observedAttributes(): string[] {
    return ['handle', 'dynamic', 'allowed-markets']
  }

  protected requiredAttributes(): string[] {
    return ['handle']
  }

  public loadedPages: number[] = []

  public scope: Scope = {
    handle: undefined,
    dynamic: true,
    allowedMarkets: [],
    load: this.load,
  }

  public goToBlog(event?: Event) {
    let url: string | URL | undefined = (
      event?.target as HTMLAnchorElement | null
    )?.href

    if (!url && this.scope.handle) {
      url = ShopifyBlogService.getBlogUrl(this.scope.handle, 1)
    }

    if (url) {
      const href = url.toString()
      if (window.location.href === href) {
        console.debug('[sb-sub-blog] Already on the blog page, do nothing')
        return
      }
      if (window.router_enable) {
        // Do nothing, the router does all for us on anchor elements
      } else {
        redirectToPath(url.toString())
      }
    }
  }

  public async load(event?: Event) {
    if (!this.scope.dynamic) {
      return this.goToBlog(event)
    }

    throw new Error('Loading the blog dynamically is not implemented yet!')
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbSubBlogComponent.observedAttributes)
  }

  async beforeBind() {
    // Remove the blog if the current market is not in the allowlist
    if (!isInMarketAllowlist(this.scope.allowedMarkets)) {
      this.remove()
    }
    await super.beforeBind()
  }

  protected async afterBind() {
    await super.afterBind()
    this.classList.add(`${SbSubBlogComponent.tagName}-ready`)
  }

  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
